import React from 'react';
import { SiteContent } from '../data/content';

interface PrinciplesProps {
  content: SiteContent['principles'];
}

export const Principles: React.FC<PrinciplesProps> = ({ content }) => {
  return (
    <section className="principles-section" id="principles" aria-labelledby="principles-title">
      <div className="container">
        <div className="section-head section-head--split">
          <div>
            <p className="eyebrow">{content.eyebrow}</p>
            <h2 id="principles-title" className="section-title">
              {content.title} <em>{content.titleEmphasis}</em>
            </h2>
          </div>
          <p className="section-aside-text">{content.aside}</p>
        </div>

        <div className="principles-editorial-grid">
          {content.items.map((p) => (
            <article key={p.id} className="principle-editorial-item">
              <div className="principle-top-row">
                <span className="principle-num">{p.index}</span>
                <span className="principle-keyword">{p.keyword}</span>
              </div>
              <h3 className="principle-title">{p.title}</h3>
              <p className="principle-desc">{p.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
